import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const Basic = (props: {rowData: [], defaults: object, field: string, persist: Function}) => {
  const emptyRecord = {
    amt: null
  }
  const [data, setData] = useState<object|null>({...props.rowData});

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    _.set(nextData, "areadetail", null)
    nextData[field] = val
    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'areadetail', props.rowData)
  }

  useEffect(() => {
    if (!props['rowData'] || props['rowData']['inputtype'] !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  const attrs = (field) => field_attrs('area')(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amt</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="amt" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default Basic
